import type { VerifiablePresentation } from './index';

export type SignPresentationResponse = {
  verifiablePresentation: VerifiablePresentation,
};
